// Célula de conversão padrão (downsell/upsell/disparo): % em cima, pago/gerado
// (PIX) embaixo. paid ⊆ generated, então a % nunca passa de 100%.
export default function ConversionCell({ paid = 0, generated = 0 }) {
    const pct = generated > 0 ? ((paid / generated) * 100).toFixed(1) : '0.0';
    return (
        <div>
            <span className="font-medium">{pct}%</span>
            <div className="text-xs text-white/40 mt-0.5">{paid}/{generated} PIX</div>
        </div>
    );
}
